import PlaceHolder from '../images/placeholder.webp';
import LogoLrgTag from '../images/new-logo-lrg-tag.svg';
import LogoLrg from '../images/new-logo-lrg.svg';
import LogoVTag from '../images/new-logo-v-tag.svg';
import LogoV from '../images/new-logo-v.svg';
import LandscapePH1 from '../placeholders/placeholder-landscape-1.png';
import LandscapePH2 from '../placeholders/placeholder-landscape-2.png';
import LandscapePH3 from '../placeholders/placeholder-landscape-3.png';
import SearchIcon from '../images/search-icon.webp';
import HeroImage from '../images/My_Job_Match_Hero_cropped.png';
import PlaceHolderWide from '../images/placeholder-wide.webp';
import Avatar from '../images/avatar.webp';
import SuggestedBadge from '../images/MJM_suggested.webp';
import Celebration from '../images/celebration.png';

const Image = {
  PlaceHolder,
  LogoLrgTag,
  LogoLrg,
  LogoVTag,
  LogoV,
  LandscapePH1,
  LandscapePH2,
  LandscapePH3,
  SearchIcon,
  HeroImage,
  PlaceHolderWide,
  Avatar,
  SuggestedBadge,
  Celebration,
};

export default Image;
